function CalculatorPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Shipping Calculator</h1>
        <p className="text-gray-600">Cost calculation coming soon...</p>
      </div>
    </div>
  );
}

export default CalculatorPage;
